import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "../../../shadcn/components/ui/Button";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API = process.env.REACT_APP_API_URL;

export default function ProfileForm() {
  // the saved data from signup journey to be displayed in the myprofile setion
  const handleFileUpload = (e) => {};
  const API = process.env.REACT_APP_API_URL;
  const [isSubmiting, setIsSubmiting] = useState(false);

  const token = localStorage.getItem("authToken");
  // State for managing form data
  const [formData, setFormData] = useState({
    profileFormData: {
      personalDetails: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        education: "",
        countryOfBirth: "",
        birthDate: "",
      },
      businessProfile: {
        industry: "",
        companyName: "",
        DBA: "",
        dateOfEstablishment: "",
        address: "",
        mailingAddress: "",
        territoriesServiced: "",
        phoneAndFaxNumbers: "",
        emailAddress: "",
        websiteURL: "",
        noOfEmployees: 0,
        businessDescription: "",
        vision: "",
        mission: "",
        valueStatement: "",
        servicesOffered: "",
        industryInformation: "",
        businessphone: "",
      },
      uploadFiles: {
        productPortfolio: [],
        awards: [],
        testimonials: [],
        certificate: [],
        specialDesigned: [],
      },
    },
    token: "",
  });

  // Handle input field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    const [section, field] = name.split(".");

    if (formData.profileFormData[section]) {
      setFormData((prevData) => ({
        ...prevData,
        profileFormData: {
          ...prevData.profileFormData,
          [section]: {
            ...prevData.profileFormData[section],
            [field]: value,
          },
        },
      }));
    } else {
      console.error(`Section ${section} not found in profileFormData.`);
    }
  };

  // Handle file uploads
  const handleFileChange = (e, category) => {
    const files = Array.from(e.target.files).map((file) =>
      URL.createObjectURL(file)
    );
    setFormData((prev) => ({
      ...prev,
      profileFormData: {
        ...prev.profileFormData,
        uploadFiles: {
          ...prev.profileFormData.uploadFiles,
          [category]: [
            ...(prev.profileFormData.uploadFiles[category] || []),
            ...files,
          ],
        },
      },
    }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    setIsSubmiting(true);

    if (!formData.token) {
      console.error("Token is missing or undefined");
      toast.error("Token is missing or undefined");
      setIsSubmiting(false);
      return;
    }

    try {
      const response = await axios.post(
        `${API}/api/v1/alluser/profile-form/submit`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Success:", response.data);
      toast.success("Form submitted successfully!");
      setIsSubmiting(false);
    } catch (error) {
      console.error("Error response:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
      setIsSubmiting(false);
    }
  };
  const handleEdit = async () => {
    try {
      const formId = localStorage.getItem("formid");
      const token = localStorage.getItem("authToken"); // Ensure the correct token key is used

      if (!token) {
        console.error("No token found");
        toast.error("Authorization token is missing.");
        return;
      }

      const updatedFormData = {
        form_id: formId,
        profileFormData: {
          personalDetails: formData.profileFormData.personalDetails,
          businessProfile: formData.profileFormData.businessProfile,
          uploadFiles: formData.profileFormData.uploadFiles,
        },
        token,
      };

      console.log(updatedFormData); // Log for debugging

      const response = await axios.put(
        `https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/profile-form/update`,
        updatedFormData
      );

      if (response.data) {
        setFormData((prev) => ({
          ...prev,
          profileFormData: {
            ...prev.profileFormData,
            ...response.data.profileFormData,
          },
        }));

        toast.success("Form data updated successfully!");
      }
    } catch (error) {
      console.error(
        "Error updating data:",
        error.response?.data || error.message
      );
      toast.error("Failed to update form data. Please try again.");
    }
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) throw new Error("Token not found");

        const response = await axios.post(
          `${API}/api/v1/alluser/profile-form/get`,
          { token }
        );

        const profileData = response.data.form_data[0]; // Adjust based on your data structure
        const data = response.data.form_data[0]._id;
        localStorage.setItem("formid", data);
        setFormData({
          profileFormData: {
            personalDetails: {
              firstName: profileData.personalDetails.firstName || "",
              lastName: profileData.personalDetails.lastName || "",
              mobileNumber: profileData.personalDetails.mobileNumber || "",
              address: profileData.personalDetails.address || "",
              city: profileData.personalDetails.city || "",
              state: profileData.personalDetails.state || "",
              zip: profileData.personalDetails.zip || "",
              email: profileData.personalDetails.email || "",
              education: profileData.personalDetails.education || "",
              countryOfBirth: profileData.personalDetails.countryOfBirth || "",
              birthDate: profileData.personalDetails.birthDate || "",
            },
            businessProfile: {
              industry: profileData.businessProfile.industry || "",
              companyName: profileData.businessProfile.companyName || "",
              DBA: profileData.businessProfile.DBA || "",
              dateOfEstablishment:
                profileData.businessProfile.dateOfEstablishment || "",
              address: profileData.businessProfile.address || "",
              mailingAddress: profileData.businessProfile.mailingAddress || "",
              territoriesServiced:
                profileData.businessProfile.territoriesServiced || "",
              phoneAndFaxNumbers:
                profileData.businessProfile.phoneAndFaxNumbers || "",
              emailAddress: profileData.businessProfile.emailAddress || "",
              websiteURL: profileData.businessProfile.websiteURL || "",
              noOfEmployees: profileData.businessProfile.noOfEmployees || 0,
              businessDescription:
                profileData.businessProfile.businessDescription || "",
              vision: profileData.businessProfile.vision || "",
              mission: profileData.businessProfile.mission || "",
              valueStatement: profileData.businessProfile.valueStatement || "",
              servicesOffered:
                profileData.businessProfile.servicesOffered || "",
              industryInformation:
                profileData.businessProfile.industryInformation || "",

              businessphone: profileData.businessProfile.businessphone || "",
            },
            uploadFiles: {
              productPortfolio: profileData.uploadFiles.productPortfolio || [],
              awards: profileData.uploadFiles.awards || [],
              testimonials: profileData.uploadFiles.testimonials || [],
              certificate: profileData.uploadFiles.certificate || [],
              specialDesigned: profileData.uploadFiles.specialDesigned || [],
            },
          },
          token,
        });
      } catch (error) {
        console.error("Error fetching profile data:", error);
        toast.error("Failed to fetch profile data");
      }
    };

    fetchProfileData();
  }, [API]);
  // Initialize token on component mount
  useEffect(() => {
    const tokenFromStorage = localStorage.getItem("authToken");
    if (tokenFromStorage) {
      setFormData((prev) => ({
        ...prev,
        token: tokenFromStorage,
      }));
    } else {
      console.error("Token not found in localStorage");
    }
  }, []);

  // Initialize token on component mount
  useEffect(() => {
    const tokenFromStorage = localStorage.getItem("authToken");
    if (tokenFromStorage) {
      setFormData((prev) => ({
        ...prev,
        token: tokenFromStorage,
      }));
    } else {
      console.error("Token not found in localStorage");
    }
  }, []);
  return (
    <div>
      <div className="container mx-auto p-4">
        <form className="space-y-8" onSubmit={(e) => e.preventDefault()}>
          <div className="bg-white p-6 rounded-lg">
            <h2 className="text-2xl font-bold pb-2 mb-4 flex flex-wrap gap-2">
              {" "}
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1494_2976)">
                  <path
                    d="M25.348 22.618L20.308 25.474C20.056 25.642 19.678 25.642 19.426 25.474L14.428 22.618C14.218 22.492 14.218 22.24 14.428 22.156L15.604 21.484C15.688 21.442 15.772 21.442 15.856 21.484L18.922 23.206C19.216 23.374 19.552 23.458 19.888 23.458C20.224 23.458 20.56 23.374 20.854 23.206L23.92 21.484C24.004 21.442 24.088 21.442 24.172 21.484L25.348 22.156C25.558 22.24 25.558 22.492 25.348 22.618ZM25.348 19.384L20.308 22.24C20.056 22.408 19.678 22.408 19.426 22.24L14.428 19.384C14.218 19.258 14.218 19.006 14.428 18.922L15.604 18.25C15.688 18.208 15.772 18.208 15.856 18.25L18.922 19.972C19.216 20.14 19.552 20.224 19.888 20.224C20.224 20.224 20.56 20.14 20.854 19.972L23.92 18.25C24.004 18.208 24.088 18.208 24.172 18.25L25.348 18.922C25.558 19.006 25.558 19.258 25.348 19.384ZM19.468 19.048L14.428 16.192C14.218 16.066 14.218 15.814 14.428 15.73L19.468 12.874C19.72 12.706 20.098 12.706 20.35 12.874L25.39 15.73C25.6 15.856 25.6 16.108 25.39 16.192L20.35 19.048C20.098 19.174 19.72 19.174 19.468 19.048Z"
                    fill="#424856"
                  />
                  <path
                    d="M13.7979 17.4104C14.0079 17.2844 14.0079 17.0324 13.7979 16.9484L12.6219 16.2764H12.5799V15.7304C12.5799 15.7304 12.5799 15.0164 13.2099 14.6384C13.3779 14.5544 13.7139 14.3864 14.0919 14.1764C13.9239 14.0924 13.7559 14.0084 13.5879 13.9664C12.8319 13.5884 11.7399 13.2104 11.4039 12.2444C11.1939 11.7404 11.3199 11.1944 11.5719 10.7324C12.0339 10.2704 12.4539 9.85039 12.8319 9.26239C12.9159 9.09439 12.9999 9.01039 13.0839 8.84239C14.1339 7.33039 14.2599 5.27239 13.6719 3.55039C13.0419 1.70239 11.4039 0.442391 9.38786 0.400391H9.09386C7.07786 0.442391 5.39786 1.70239 4.80986 3.55039C4.17986 5.31439 4.34786 7.33039 5.39786 8.84239C5.43986 9.01039 5.56586 9.09439 5.64986 9.26239C6.02786 9.85039 6.48986 10.2284 6.90986 10.7324C7.11986 11.1944 7.20386 11.6984 7.07786 12.2444C6.78386 13.1684 5.69186 13.5884 4.89386 13.9664C3.12986 14.7224 0.945858 15.8144 0.609858 17.9564C0.231858 19.7204 1.44986 21.4844 3.29786 21.4844H12.5799L13.7979 20.6864C14.0079 20.5604 14.0079 20.3084 13.7979 20.2244L12.6219 19.5524H12.5799V18.2084L13.7979 17.4104Z"
                    fill="#424856"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1494_2976">
                    <rect width="26" height="26" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span className="bottom-1 relative">501 C3 Corporations</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label className="block text-gray-700">First Name</label>
                <input
                  type="text"
                  name="personalDetails.firstName"
                  value={formData.profileFormData.personalDetails.firstName}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter First Name"
                />
              </div>
              <div>
                <label className="block text-gray-700">Last Name</label>
                <input
                  type="text"
                  name="personalDetails.lastName"
                  value={formData.profileFormData.personalDetails.lastName}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter Last Name"
                />
              </div>
              <div>
                <label className="block text-gray-700">Mobile Number</label>
                <input
                  type="text"
                  name="personalDetails.mobileNumber"
                  value={formData.profileFormData.personalDetails.mobileNumber}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter Mobile Number"
                />
              </div>
              <div>
                <label className="block text-gray-700">Address</label>
                <input
                  type="text"
                  name="personalDetails.address"
                  value={formData.profileFormData.personalDetails.address}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter Address"
                />
              </div>
              <div>
                <label className="block text-gray-700">City</label>
                <input
                  type="text"
                  name="personalDetails.city"
                  value={formData.profileFormData.personalDetails.city}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="City"
                />
              </div>
              <div>
                <label className="block text-gray-700">State</label>
                <input
                  type="text"
                  name="personalDetails.state"
                  value={formData.profileFormData.personalDetails.state}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="State"
                />
              </div>
              <div>
                <label className="block text-gray-700">Zip</label>
                <input
                  type="text"
                  name="personalDetails.zip"
                  value={formData.profileFormData.personalDetails.zip}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Zip"
                />
              </div>
              <div>
                <label className="block text-gray-700">Email</label>
                <input
                  type="email"
                  name="personalDetails.email"
                  value={formData.profileFormData.personalDetails.email}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter Email"
                />
              </div>
            </div>
          </div>

          {/* Business Information Section */}
          <div className="bg-white p-4 rounded-lg mt-2">
            <div className="flex mx-[-1rem] gap-2">
              <svg
                width="36"
                height="36"
                className=""
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1575_887)">
                  <path
                    d="M25.348 22.618L20.308 25.474C20.056 25.642 19.678 25.642 19.426 25.474L14.428 22.618C14.218 22.492 14.218 22.24 14.428 22.156L15.604 21.484C15.688 21.442 15.772 21.442 15.856 21.484L18.922 23.206C19.216 23.374 19.552 23.458 19.888 23.458C20.224 23.458 20.56 23.374 20.854 23.206L23.92 21.484C24.004 21.442 24.088 21.442 24.172 21.484L25.348 22.156C25.558 22.24 25.558 22.492 25.348 22.618ZM25.348 19.384L20.308 22.24C20.056 22.408 19.678 22.408 19.426 22.24L14.428 19.384C14.218 19.258 14.218 19.006 14.428 18.922L15.604 18.25C15.688 18.208 15.772 18.208 15.856 18.25L18.922 19.972C19.216 20.14 19.552 20.224 19.888 20.224C20.224 20.224 20.56 20.14 20.854 19.972L23.92 18.25C24.004 18.208 24.088 18.208 24.172 18.25L25.348 18.922C25.558 19.006 25.558 19.258 25.348 19.384ZM19.468 19.048L14.428 16.192C14.218 16.066 14.218 15.814 14.428 15.73L19.468 12.874C19.72 12.706 20.098 12.706 20.35 12.874L25.39 15.73C25.6 15.856 25.6 16.108 25.39 16.192L20.35 19.048C20.098 19.174 19.72 19.174 19.468 19.048Z"
                    fill="#424856"
                  />
                </g>
              </svg>
              <h2 className="text-2xl flex items-center font-bold pb-4 mb-4 relative top-2">
                <span>Business Information</span>
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label className="block text-gray-700">Company</label>
                <input
                  type="text"
                  name="businessProfile.companyName"
                  value={formData.profileFormData.businessProfile.companyName}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Company"
                />
              </div>

              <div>
                <label className="block text-gray-700">DBA</label>
                <input
                  type="text"
                  name="businessProfile.DBA"
                  value={formData.profileFormData.businessProfile.DBA}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="DBA"
                />
              </div>

              <div>
                <label className="block text-gray-700">
                  Date Of Establishment
                </label>
                <input
                  type="text"
                  name="businessProfile.dateOfEstablishment"
                  value={
                    formData.profileFormData.businessProfile.dateOfEstablishment
                  }
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Date Of Establishment"
                />
              </div>

              <div>
                <label className="block text-gray-700">Services Area</label>
                <input
                  type="text"
                  name="businessProfile.servicesOffered"
                  value={
                    formData.profileFormData.businessProfile.servicesOffered
                  }
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Services Area"
                />
              </div>
              <div>
                <label className="block text-gray-700">
                  Level of Care Serviced
                </label>
                <input
                  type="text"
                  name="businessProfile.servicesOffered"
                  value={
                    formData.profileFormData.businessProfile.servicesOffered
                  }
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="care serviced"
                />
              </div>

              <div>
                <label className="block text-gray-700">Website URL</label>
                <input
                  type="url"
                  name="businessProfile.websiteURL"
                  value={formData.profileFormData.businessProfile.websiteURL}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Website URL"
                />
              </div>
              <div>
                <label className="block text-gray-700">Business Phone</label>
                <input
                  type="text"
                  name="businessProfile.businessphone"
                  value={formData.profileFormData.businessProfile.businessphone}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Business Phone"
                />
              </div>

              <div>
                <label className="block text-gray-700">
                  Number of Employees
                </label>
                <input
                  type="number"
                  name="businessProfile.noOfEmployees"
                  value={formData.profileFormData.businessProfile.noOfEmployees}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Number of Employees"
                />
              </div>

              <div>
                <label className="block text-gray-700">
                  Business Description
                </label>
                <textarea
                  name="businessProfile.businessDescription"
                  value={
                    formData.profileFormData.businessProfile.businessDescription
                  }
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Describe your business"
                ></textarea>
              </div>

              <div>
                <label className="block text-gray-700">Vision</label>
                <textarea
                  name="businessProfile.vision"
                  value={formData.profileFormData.businessProfile.vision}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Vision"
                ></textarea>
              </div>

              <div>
                <label className="block text-gray-700">Mission</label>
                <textarea
                  name="businessProfile.mission"
                  value={formData.profileFormData.businessProfile.mission}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Mission"
                ></textarea>
              </div>

              <div>
                <label className="block text-gray-700">Value Statement</label>
                <textarea
                  name="businessProfile.valueStatement"
                  value={
                    formData.profileFormData.businessProfile.valueStatement
                  }
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Value Statement"
                ></textarea>
              </div>
            </div>
            <h2 className="text-2xl font-bold border-b pb-4 mb-4">
              Upload Documents
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                "Product Portfolio",
                "Awards",
                "Testimonials",
                "Certifications",
                "Special Designed",
              ].map((label, index) => {
                const field = label.toLowerCase().replace(/\s+/g, ""); // Convert label to field name
                return (
                  <div
                    key={index}
                    className="bg-white border rounded-lg shadow-md p-4"
                  >
                    <h4 className="text-lg md:text-xl font-semibold mb-4 text-center">
                      {label}
                    </h4>
                    <div className="border-dashed border-2 border-gray-300 p-6 text-center rounded-lg flex flex-col items-center justify-center gap-2">
                      <svg
                        width="66"
                        height="52"
                        viewBox="0 0 66 52"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mx-auto mb-2"
                      >
                        <path
                          d="M33 50.635L33 26.945V31.065"
                          stroke="#6F7787"
                          strokeWidth="2.472"
                          strokeMiterlimit="10"
                          strokeLinecap="square"
                        />
                        <path
                          d="M21.6699 38.305L32.9999 26.975L44.3299 38.305"
                          stroke="#6F7787"
                          strokeWidth="2.472"
                          strokeMiterlimit="10"
                          strokeLinecap="square"
                        />
                        <path
                          d="M41.2397 50.6055C54.1895 49.5253 64.092 38.6031 63.9021 25.6098C63.7121 12.6164 53.4946 1.98838 40.5188 1.28711C27.5429 0.585839 16.2395 10.0508 14.6503 22.948C7.27779 23.6796 1.77369 30.0632 2.13497 37.4631C2.49626 44.863 8.59604 50.68 16.0047 50.69L24.7597 50.69"
                          stroke="#6F7787"
                          strokeWidth="2.472"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                        />
                      </svg>
                      <span className="font-bold text-gray-800">
                        Drag files here
                      </span>
                      <span className="text-gray-500 text-sm">
                        Supported format: PNG, JPG
                      </span>
                      <input
                        type="file"
                        multiple // Allow multiple files
                        onChange={(e) => handleFileChange(e, field)}
                        className="hidden"
                        id={`fileInput-${index}`}
                      />
                      <label
                        htmlFor={`fileInput-${index}`}
                        className="cursor-pointer mt-2 text-purple-600 hover:underline"
                      >
                        Browse Files
                      </label>
                      <div className="mt-4">
                        <p className="text-sm text-gray-600">
                          {formData.profileFormData.uploadFiles[field]?.length >
                          0 ? (
                            <span>
                              {
                                formData.profileFormData.uploadFiles[field]
                                  ?.length
                              }{" "}
                              file(s) selected
                            </span>
                          ) : (
                            <span>No file selected</span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-4">
            <Button onClick={handleEdit} variant="outline">
              Edit
            </Button>
            <Button
              onClick={handleSubmit}
              className="bg-purple-600 hover:bg-purple-700"
              disabled={isSubmiting}
            >
              {isSubmiting ? "Submitting..." : "Submit"}
            </Button>
            <ToastContainer />
          </div>
        </form>
      </div>
    </div>
  );
}
